import React, { useEffect, useState } from 'react'
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton'

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './NewSubsidiary.module.css';
import { LegalEntityParentCompanyServiceApi, LegalEntitySubsidiaryServicesApi } from '../../service';
import Loading from '../../components/Loading/Loading';
import GenericModal from '../../UI/GenericModal';
import { useHistory } from 'react-router-dom';
import DropdownSelect from '../../components/controls/DropdownSelect/DropdownSelect';
import { isSuperuserValue } from '../../access/access';

const NewSubsidiary = () => {
  const [allParentCompanies, setAllParentCompanies] = useState();
  const [newSubsidiaryName, setNewSubsidiaryName] = useState("");
  const [parentCompanyId, setParentCompanyId] = useState(0);
  const [authorityCode, setAuthorityCode] = useState("");
  const [isActiveSubsidiary, setIsActiveSubsidiary] = useState(true);
  
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();
  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setIsLoading(true);

    const parentCompanyService = new LegalEntityParentCompanyServiceApi();
    parentCompanyService.getAllLegalEntityParentCompany(true, (error, parentCompaniesData) => {
      console.log("API all parent companies: ", parentCompaniesData);
      if (mounted) {
        if (!error) {
          setAllParentCompanies(parentCompaniesData.sort( (a,b) => a.id > b.id ? 1 : -1));
          setIsLoading(false);
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }
    });

    return (() => {
      mounted = false;
    })
  },[]);

  const subsidiaryNameHandler = (value) => {
    setNewSubsidiaryName(value);
  }

  const authorityCodeHandler = (value) => {
    let val = value.replace(/[^A-Za-z0-9]/ig, '')
    val = val.toUpperCase();
    setAuthorityCode(val);
  }

  const parentCompanyChangeHandler = (subId) => {
    setParentCompanyId(subId)
    console.log(allParentCompanies.filter(el => el.id === subId))
  }

  const updateActiveSubsidiaryValue = (value) => {
    console.log("Active value: ", value);
    setIsActiveSubsidiary(value);
  }

  const submitFormHandler = () => {
    console.log("Submit function")
    
    if (validValues()) {
      setIsLoading(true);
      const requestBody = {
        name: newSubsidiaryName,
        active: isActiveSubsidiary,
        authorityCode: authorityCode,
        legalEntityParentCompanyId: parentCompanyId
      }
      
      console.log("requestBody: ", requestBody);
      const subsidiaryServicesApi = new LegalEntitySubsidiaryServicesApi();
      subsidiaryServicesApi.newLegalEntitySubsidiary(requestBody, (error, data) => {
        if (!error) {
          setIsLoading(false);
          modalDataHandler("", `A new subsidiary "${newSubsidiaryName}" was created`, 'notification', () => history.push("/subsidiary-monitor"))  
        } else {
          setIsLoading(false);
          modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, `An error ocurred. A new subsidiary could not be created!`, 'error', modalCloseHandler)  
        }
      })
    } else {
       modalDataHandler("", `A name must be typed for the new subsidiary.`, 'notification', modalCloseHandler)
    }
  }

  const validValues = () => {

    if (newSubsidiaryName.length === 0 || authorityCode.length === 0 || parentCompanyId === 0) {
      return false;
    } else {
      return true;
    }
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const requestBody = {
    name: newSubsidiaryName,
    active: isActiveSubsidiary,
    authorityCode: authorityCode,
    legalEntitySubsidiaryId: parentCompanyId
  }

  console.log("requestBody: ", requestBody);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        modalDataHandler(
          "Add Subsidiary",
          "Add new subsidiary?",
          "confirmation",
          submitFormHandler
        );
      }}
    >
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      <div className="d-flex justify-content-between mt-2">
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Subsidiary
          </label>
          <input
            className={styles.textInput}
            type="text"
            value={newSubsidiaryName}
            onChange={(e) => {
              subsidiaryNameHandler(e.target.value);
            }}
            placeholder="Type subsidiary name"
          />
        </div>
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Authority Code
          </label>
          <input
            className={`${styles.textInput}`}
            type="text"
            // pattern="[A-Z0-9-]+"
            maxLength="9"
            size="14"
            value={authorityCode}
            onChange={(e) => {
              authorityCodeHandler(e.target.value);
            }}
            placeholder="Type authority code"
          />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="active" className="mb-1 fw-bold">
            Active
          </label>
          <input
            type="checkbox"
            id="active"
            className={styles.activeCheckbox}
            name="activeValue"
            checked={isActiveSubsidiary}
            onChange={(e) => {
              updateActiveSubsidiaryValue(e.target.checked);
            }}
          />
        </div>
        <div>
          <img src={nexiLogo} className={`${styles.logo}`} alt="nexi-group" />
        </div>
      </div>
      <div className="hr position-relative mt-4"></div>
      {isLoading && <Loading height={"82px"} />}
      {!isLoading && (
        <div className="d-flex justify-content-between mb-4">
          <div className="d-flex">
            <div className="me-5">
              <label className="fw-bold mb-1 mt-4 ms-1">Parent Company</label>
              {allParentCompanies && (
                <DropdownSelect
                  data={allParentCompanies}
                  name={"parentCompanies"}
                  emptyListMessage={"Select a Parent Company"}
                  defaultValue={parentCompanyId}
                  onChange={parentCompanyChangeHandler}
                  //  onChange={event => controlFunctionChange(event)}
                ></DropdownSelect>
              )}
            </div>
          </div>
          <div className="d-flex align-items-end">
            <SubmitButton
              type="submit"
              disabled={!validValues()}
              class={`${styles.submitButton} mt-3 mb-1 me-3 float-end`}
            >
              Add
            </SubmitButton>
          </div>
        </div>
      )}
    </form>
  );
}

export default NewSubsidiary;
